import FormRow from 'components/FormRow';
import ToggleCheckbox from 'components/ui/ToggleCheckbox';
import Section from 'pages/Account/components/Section';
import useMarketing from './hooks/useMarketing';

const MarketingSection = () => {
  const { marketing, isLoading, onMarketingChange } = useMarketing();

  return (
    <Section maxWidth={400} title="마케팅 수신 동의">
      <FormRow label="서비스 공지 및 알림을 이메일로 수신받습니다." direction="row">
        <ToggleCheckbox id="marketing" checked={marketing} disabled={isLoading} onChange={onMarketingChange} />
      </FormRow>
    </Section>
  );
};

export default MarketingSection;
